import AnimatedText from "../components/AnimatedText";

import "../styles/latest.css";

const Latest = () => {
  return (
    <section id="latest">
      <div className="container">


      </div>
    </section>
  );
};

export default Latest;
